// src/pages/SettingsPage.tsx
import React from "react";
import { useNavigate } from "react-router-dom";
import { useTheme } from "../context/ThemeContext";
import { Moon, Sun, LogOut } from "lucide-react";

const SettingsPage: React.FC = () => {
  const { dark, toggle } = useTheme();
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem("authToken");
    navigate("/login");
  };

  return (
    <div className="settings-page container-fluid py-4">
      <h3 className="fw-bold mb-4">Settings</h3>

      <div className="card shadow-sm border-0">
        <div className="card-body">
          <h5 className="card-title fw-semibold mb-3">Preferences</h5>

          {/* Theme Toggle */}
          <div className="form-check form-switch mb-4">
            <input
              className="form-check-input"
              type="checkbox"
              id="themeSwitch"
              checked={dark}
              onChange={toggle}
            />
            <label
              className="form-check-label d-flex align-items-center"
              htmlFor="themeSwitch"
            >
              {dark ? (
                <Sun size={18} className="me-2 text-warning" />
              ) : (
                <Moon size={18} className="me-2 text-secondary" />
              )}
              {dark ? "Light Mode" : "Dark Mode"}
            </label>
          </div>

          <hr />

          {/* Logout Button */}
          <button
            onClick={handleLogout}
            className="btn btn-outline-danger d-flex align-items-center"
          >
            <LogOut size={18} className="me-2" /> Log Out
          </button>
        </div>
      </div>
    </div>
  );
};

export default SettingsPage;
